var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('youtube',{ref:"youtube",attrs:{"video-id":this.yt_video_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }